// extracted by mini-css-extract-plugin
module.exports = {"container":"OpportunityCanceledForm-module__container--BcTqd","otherReasonTextarea":"OpportunityCanceledForm-module__otherReasonTextarea--16qcO"};